import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ToastProvider } from './components/ui';
import { ApiProblem, createApiClient } from './lib/api';
import { createAuth } from './lib/auth';
import { loadRuntimeConfig } from './lib/config';
import { ServicesProvider } from './lib/context';
import { router } from './router';
import './styles/app.css';

const root = createRoot(document.getElementById('root')!);

try {
  const config = await loadRuntimeConfig();
  const auth = createAuth(config);
  const api = createApiClient(config.apiBaseUrl, auth, () => {
    if (!window.location.pathname.startsWith('/login')) {
      void router.navigate({ to: '/login', search: { returnTo: window.location.pathname } });
    }
  });
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        // Client errors (403/404/422) will not change on retry.
        retry: (count, err) =>
          !(err instanceof ApiProblem && err.status >= 400 && err.status < 500) && count < 2,
      },
    },
  });

  root.render(
    <StrictMode>
      <ServicesProvider value={{ config, auth, api }}>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </QueryClientProvider>
      </ServicesProvider>
    </StrictMode>,
  );
} catch {
  root.render(
    <main className="auth" data-single>
      <div className="auth-card">
        <h1>No pudimos iniciar la aplicación</h1>
        <p>La configuración del ambiente no está disponible. Recarga la página en unos minutos.</p>
      </div>
    </main>,
  );
}
